import { IExtendableDto, SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import { ISearchCriteria } from "../models";

export class DriverApi {
  static async resetPassword(
    driverId: number,
    abortController?: AbortController,
  ): Promise<SimpleResult<void> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/drivers/${driverId}/reset_password`;
    const response = await Api.patch<SimpleResult<void> | undefined>(
      requestUrl,
      {},
      abortController,
    );

    return response?.data;
  }

  static async searchDriverByCriteria(
    payload: ISearchCriteria<string>,
  ): Promise<SimpleResult<IExtendableDto[]> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/drivers/search`;
    const response = await Api.post<SimpleResult<IExtendableDto[]>>(
      requestUrl,
      payload,
    );
    return response?.data;
  }
}
